import orderBy from "lodash/orderBy";

type Data = Record<string, unknown> & { isPrimary: boolean };

type CreateOrderedDataSchema = {
    primaryData: Data;
    competitorsData: Data[];
    withOthers: boolean;
    isPrimaryInTop: boolean;
    otherData?: Data;
    sorted?: boolean;
};

export const createOrderedData = ({
    primaryData,
    competitorsData = [],
    otherData,
    withOthers,
    isPrimaryInTop,
    sorted = true,
}: CreateOrderedDataSchema): Data[] => {
    const allData = [primaryData, ...competitorsData];
    const sortedData = sorted ? orderBy(allData, "rank", "asc") : allData;

    if (!withOthers || !otherData) {
        return sortedData;
    }

    if (isPrimaryInTop) {
        return [...sortedData, otherData];
    }

    const allWithOthers = [...allData, otherData];

    return sorted ? orderBy(allWithOthers, "rank", "asc") : allWithOthers;
};
